import React from 'react';

import { BaseProps } from '../../types';

import { formatCurrency } from '../../utils/formatters';

export interface CurrencyProps extends BaseProps {
  amount?: string | null;
  precision?: number;
  nullLabel?: string;
  currencyLabel: string;
}

export function Currency({
  amount,
  precision = 2,
  nullLabel = 'N/A',
  currencyLabel,
}: CurrencyProps) {
  if (amount == null) {
    return <>{nullLabel}</>;
  }

  return <>{formatCurrency(amount, currencyLabel, { precision })}</>;
}

export default Currency;
